





































































































































































import SaascadaVue from '@/components/Shared/SaascadaVue';
import { Component } from 'vue-property-decorator';
import { ProductMigrationModule } from '@/store/Products/ProductMigrationModule';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import ProductMigrationState from '@/components/Products/ProductMigrations/ProductMigrationState.vue';
import ProductMigrationStateModel from '@/models/Products/ProductMigrations/ProductMigrationState';
import PageNames from '@/router/PageNames';

@Component({ name: 'ProductMigrationDetails',  components: { ProductMigrationState } })
export default class extends SaascadaVue {

    ProductMigrationStateModel = ProductMigrationStateModel;

    get productMigration() {
        return ProductMigrationModule.productMigration;
    }

    async deleteProductMigration() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this product migration?', options);
        if (result) {
            await ProductMigrationModule.deleteProductMigration(ProductMigrationModule.productMigration.id);
            await ProductMigrationModule.getProductMigrations(1);
            this.$router.push({ name: PageNames.ProductMigrations });
        }
    }

}
